import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { LocaleLookupModel } from 'app/generated/backend/localization/api/locale-lookup-model';
import { BaseIdInputTypeaheadComponent } from 'app/_templates/base-id-input-typeahead/BaseIdInputTypeaheadComponent';
import { CoreLocaleLookupService } from "./CoreLocaleLookupService";


export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
	provide: NG_VALUE_ACCESSOR,
	useExisting: forwardRef(() => CoreLocaleLookupComponent),
	multi: true
};

export const CUSTOM_INPUT_CONTROL_VALIDATORS: any = {
	provide: NG_VALIDATORS,
	useExisting: forwardRef(() => CoreLocaleLookupComponent),
	multi: true
};

@Component({
    selector: 'app-core-locale-lookup',
    templateUrl: '../../_templates/base-id-input-typeahead/BaseIdInputTypeaheadComponent.html',
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR, CUSTOM_INPUT_CONTROL_VALIDATORS],
    standalone: false
})
export class CoreLocaleLookupComponent extends BaseIdInputTypeaheadComponent<LocaleLookupModel> {

	@Input()
	public required: boolean = false;

	@Input()
	public disabled: boolean = false;

	@Input()
	public addNew: boolean = false;

	@Input()
	public maxOptions: number;

	@Input()
	public label: string;

	@Input()
	public iconClass: string;

	@Input()
	public placeholder: string = '';

	@Input()
	public helpUri: string;

	@Input()
	public hint: string;

	@Output()
	itemSelected: EventEmitter<LocaleLookupModel> = new EventEmitter<LocaleLookupModel>();

	constructor(protected service: CoreLocaleLookupService) {
		super(service);
	}

	toDisplayText(item: LocaleLookupModel): string {
		if (!item) {
			return null;
		}
		return item.name;
	}

	toOptionText(item: LocaleLookupModel): string {
		if (!item) {
			return null;
		}
		return item.name;
	}
}
